const setPasswordReturnUrlKey = "set-password-return-url";

export const setPasswordReturnUrl = (returnUrl: string) => {
  localStorage.setItem(setPasswordReturnUrlKey, returnUrl);
};

export const getPasswordReturnUrl = (): string | null => {
  return localStorage.getItem(setPasswordReturnUrlKey);
};

export const removePasswordReturnUrl = () => {
  localStorage.removeItem(setPasswordReturnUrlKey);
};
